<template>
    <section id="content" class="gray-area">
        <div class="container">
            <div id="main">
                &nbsp;
            </div>
        </div>
    </section>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function () {

            return {

            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([


            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc: Make 'Get Bookings' Call.
        * Note: Send 'authorizationHeader' here.
        *
        */
        mounted: function () {


        }, // eo function mounted()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([

            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>

</style>
